var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperadminDashobardItemBalanceRequestsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.381,
    height: 45.876,
    viewBox: "0 0 39.381 45.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Paper",
    d: "M10.586,45.876A10.562,10.562,0,0,1,0,35.111V10.372a10.134,10.134,0,0,1,3.138-7.3A10.64,10.64,0,0,1,10.586.027H25.038a1.75,1.75,0,0,1,.613,0h.3A1.743,1.743,0,0,1,27.2.559L38.9,12.743a1.736,1.736,0,0,1,.484,1.2V35.111c0,5.834-4.737,10.764-10.344,10.764Zm0-42.384a7.1,7.1,0,0,0-7.121,6.88v24.74A7.377,7.377,0,0,0,5.516,40.3a7.013,7.013,0,0,0,5.069,2.108h18.45a6.706,6.706,0,0,0,4.826-2.184,7.549,7.549,0,0,0,2.054-5.115l0-18.985-2.02.007c-.771,0-1.648,0-2.623,0a7.676,7.676,0,0,1-7.647-7.243l-.012-.434V3.49Zm16.49,4.959a4.212,4.212,0,0,0,4.2,4.213h2.739l-6.942-7.23ZM12.442,33.041a1.732,1.732,0,0,1-.235-3.448l.235-.015H24.906a1.732,1.732,0,0,1,.235,3.448l-.235.015Zm0-11.436a1.732,1.732,0,0,1-.235-3.448l.235-.017H20.19a1.732,1.732,0,0,1,.235,3.448l-.235.017Z",
    fill: "#199b8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperadminDashobardItemBalanceRequestsIcon);
export default __webpack_public_path__ + "static/media/superadmin-dashobard-item-balance-requests-icon.4d200b5a324302c09b79071b691751d0.svg";
export { ForwardRef as ReactComponent };